/**
 * Parallax scroll effect for Custom Promo Banner.
 * Uses the Global EcommerceCore GSAP instance.
 */
export const initPromoBannerParallax = (): void => {
  const banners = document.querySelectorAll<HTMLElement>(".theme-custom-promo");
  if (banners.length === 0) return;

  // 1. Get the raw object
  const rawGsap = window.EcommerceCore.vendors.gsap;
  const rawScrollTrigger = window.EcommerceCore.vendors.ScrollTrigger;

  // 2. Handle ES Module interop (ESM vs CJS)
  // Check if it's nested under 'default' (common in Vite/Rollup builds)
  const gsap = (rawGsap as any).default || rawGsap;
  const ScrollTrigger = (rawScrollTrigger as any).default || rawScrollTrigger;

  gsap.registerPlugin(ScrollTrigger);

  banners.forEach((banner) => {
    const bgImage = banner.querySelector<HTMLElement>(
      ".theme-custom-promo__bg",
    );
    if (!bgImage) return;

    gsap.fromTo(
      bgImage,
      { yPercent: -15 },
      {
        yPercent: 15,
        ease: "none",
        scrollTrigger: {
          trigger: banner,
          start: "top bottom",
          end: "bottom top",
          scrub: 0.5,
        },
      },
    );
  });
};
